module.exports = __webpack_public_path__ + "static/typhoid-14f3617cd7581c2941372782ab52d72b.png";